import * as angular from "angular";
import {IController} from "angular";

export class ErrorPageViewComponent implements IController {

  constructor(private $state) {
  }

  back() {
    this.$state.go('organizations.overview');
  };

  login() {
    this.$state.go('authentication.login');
  };

}

angular
  .module('bringoz.admin.commons')
  .component('errorPageView', {
    bindings: {
      template: '<'
    },
    templateUrl: getTemplateUrl,
    controller: ErrorPageViewComponent
  });

function getTemplateUrl($element, $attrs) {
  let templates = {
    '403': 'app/modules/commons/components/error-pages/views/403.html',
    '404': 'app/modules/commons/components/error-pages/views/404.html',
    '500': 'app/modules/commons/components/error-pages/views/500.html',
  };
  return templates[$attrs.template || '500'];
}
